import Vue from "vue";
import App from "./App.vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import router from "./router";
import store from "./store";
import Multiselect from "vue-multiselect";
import { mapState, mapActions } from "vuex";
import $ from "jquery";
Vue.config.productionTip = false;
Vue.config.devtools = true;

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.component("multiselect", Multiselect);
import VueFlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
Vue.use(VueFlatPickr);

import VueSweetalert2 from "vue-sweetalert2";

let rate_period2;
rate_period2 = null;
let rate_period3;
rate_period3 = null;
let rate_period4;
rate_period4 = null;

Vue.use(VueSweetalert2);

import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const numberFormats = {
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD'
    }
  },
  'ja-JP': {
    currency: {
      style: 'currency',
      currency: 'JPY',
      currencyDisplay: 'symbol'
    }
  },
  'nl-NL': {
    currency: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol',
    }
  },
  'nl-DC': {
    currency: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 6
    }
  }
}

const i18n = new VueI18n({
  numberFormats
});

Vue.mixin({
  computed: {
    ...mapState({
      form: (state) => state.forms.formStateData,
      lang: (state) => state.forms.lang,
      languages: (state) => state.forms.languages,
      translate: (state) => state.translate.translate,
      durations: (state) => state.forms.durations,
      meter: (state) => state.forms.meter,
      energieGroups: (state) => state.products.energieGroups,
      overview: (state) => state.forms.overview,
      disciplineCode: (state) => state.forms.disciplinecode,
      enums: (state) => state.forms.enums,
      postcodeQuery: (state) => state.forms.postcodeQuery,
      languageEnum: (state) => state.forms.languageEnum,
      edit: (state) => state.forms.edit,
      rates: (state) => state.forms.rates,
      addressResidential: (state) => state.forms.addressResidential,
      solar: (state) => state.forms.solar,
      solars: (state) => state.forms.solars,
      consumption: (state) => state.forms.consumption,
    }),

    /** removeProducts parameter */
    listToDelete() {
      if (this.$route.query.removeProducts) {
        return this.$route.query.removeProducts.split(',').map( Number );
      } else {
        return [];
      }
    },
    selectedProducts() {
      let selectedPro = [];
      this.form.data.fields
        .filter((x) => x.type === "products")
        .forEach((x) => {
          if (x.defaultProducts.length > 0) {
            x.defaultProducts.forEach((y) => {
              selectedPro.push(y);
            });
          }
        });

      return $(selectedPro).not(this.listToDelete).get();
    },
     /** End of removeProducts parameter */


    /** allowedProducts parameter */
    allowedProducts() {
      if (this.$route.query.allowedProducts) {
        return this.$route.query.allowedProducts.split(',').map( Number );
      } else {
        return [];
      }
    },

    selectedAllowedProducts() {
      let selectedPro = [];
      this.form.data.fields
        .filter((x) => x.type === "products")
        .forEach((x) => {
          if (x.defaultProducts.length > 0) {
            x.defaultProducts.forEach((y) => {
              selectedPro.push(y);
            });
          }
        });
      return $(selectedPro).filter(this.allowedProducts).get();
    },
    /** End of allowedProducts parameter */
    
    products() {
      var arrs = this.form.data.fields
        .filter((item) => item.type === "products")
        .map((a) => a.products);
      let arrsModified = [];
      arrs.forEach((a) => {
        a.forEach((b) => {
          arrsModified.push(b);
        });
      });
      if (this.selectedAllowedProducts.length > 0) {
        return arrsModified.filter((item) => this.allowedProducts.includes(item.id)).filter((item) => !this.listToDelete.includes(item.id));
      } else {
        return $(arrsModified).not(this.listToDelete).get();
      }
    },
    isMobile() {
      return window.innerWidth <= 767;
    },
    isOverview() {
      // return document.getElementById("sideBarRight") != null
      // return this.overview.length > 0
      return (
        document.getElementById("sideBarRight") != null ||
        document.getElementById("mobile-overwiev") != null
      );
    },
    customertype() {
      return this.form.data.customertype;
    },
    
    defaultProducts() {
      var arrs = this.form.data.fields
        .filter((item) => item.type === "products")
        .map((a) => a.defaultProducts);
      let arrsModified = [];
      arrs.forEach((a) => {
        a.forEach((b) => {
          arrsModified.push(b);
        });
      });
      return arrsModified;
    },
    checkElectricGas() {
      if (
        this.selectedProducts.indexOf(1) >= 0 &&
        this.selectedProducts.indexOf(2) >= 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    overviewPerMonthTotal() {
      let total = 0;
      this.overview
        .filter((o) => o.visible === 1)
        .forEach((item) => {
            total += item.yearly / 12;
        });
      return total;
    },
    overviewTotal() {
      let total = 0;
      this.overview
        .filter((o) => o.visible === 1)
        .forEach((item) => {
          if (item.group !== "hypotheek") {
            if (item.discountTotal) {
              console.log("1");
              total +=
                (item.yearly / 12) * (12 - item.discounts[0].period) +
                item.discountTotal;
            } else {
              // console.log("2")
              total += item.yearly;
            }
          }
        });
      return total;
    },
    isLead() {
      return this.form.data.action == 0 ? true : false;
    },
    hasProduct() {
      return this.products.length > 0 ? true : false;
    },
    isSubmittedForm() {
      return !!this.$route?.params?.submitid;
    },
    showEdit() {
      return !!(this.$route?.params?.submitid && this.$route?.params?.id);
    },
    disabledForm() {
      return this.isSubmittedForm && !this.edit;
    },
  },
  methods: {
    ...mapActions({
      getRates: "forms/getRates",
      getSupplier: "suppliers/getSupplier",
    }),
    ruleExceptObject(checkDiscount) {
      let temp = [];
      checkDiscount.forEach((p) => {
        temp.tv = p.except.tv ?? temp.tv;
        temp.call = p.except.call ?? temp.call;
      });
      return temp;
    },
    setOverview() {
      this.selectedProducts.forEach((item) => {
        let product = this.filterProduct(item);
        let supplier = this.defaultSupplier(this.energieGroups[item]);
        let overviewFiltered = this.overview.filter((x) => x.id === item);
        if (overviewFiltered.length === 0) {
          //console.log(11111)
          this.$store.state.forms.overview.push({
            id: product.id,
            product: product.name /* [this.lang] */,
            supplier: {
              id: supplier ? supplier.supplier_id : null,
              proposition: supplier ? supplier.id : null,
              name: supplier ? supplier.name : null,
              title: supplier ? supplier.title : null,
            },
            duration: "",
            total: 0,
            onetimetotal: 0,
            discount: 0,
            yearly: 0,
            visible: 1,
            rates: [],
            packages: [],
            widgets: [],
            packagestotal: 0,
            group: this.energieGroups[item],
            details: null,
          });

          if (this.checkElectricGas && (item === 1 || item === 2)) {
            this.setProduct6();
          } else if (item == 3 || item == 7) {
            return; // do not need any rates because dont have any proposition.
          } else {
            this.setRates(item);
          }
        } else {
          let suppliersPackages = overviewFiltered[0].packages.filter(
            (x) => x.supplier_id === supplier.supplier_id
          );
          overviewFiltered[0].supplier.id =
            supplier.supplier_id ?? overviewFiltered[0].supplier.id;
          overviewFiltered[0].supplier.proposition =
            supplier.id ?? overviewFiltered[0].supplier.proposition;
          overviewFiltered[0].supplier.name =
            supplier.name ?? overviewFiltered[0].supplier.name;
          overviewFiltered[0].supplier.title =
            supplier.title ?? overviewFiltered[0].supplier.title;
          overviewFiltered[0].duration = "";
          overviewFiltered[0].packages =
            suppliersPackages.length > 0 ? suppliersPackages : [];
          if (suppliersPackages.length === 0) {
            overviewFiltered[0].packagestotal = 0;
          }
        }
        if (item === 61) {
          // ContractCoach
          this.setContractCoach();
        }
      });
      if (this.checkElectricGas) {
        this.overview.filter((x) => x.id === 1)[0].visible = 0;
        this.overview.filter((x) => x.id === 2)[0].visible = 0;
      }
    },
    setContractCoach() {
      let overviewFiltered = this.overview.filter((x) => x.id === 61);
      this.getSupplier(61).then((res) => {
        let temp = res.data.data.filter((x) => x.propositions.length > 0)[0];
        let proposition = temp.propositions[0];

        overviewFiltered[0].supplier.id = res.data.data[0].id;
        overviewFiltered[0].supplier.proposition = proposition.proposition_id;
        overviewFiltered[0].supplier.name = proposition.name;
        overviewFiltered[0].yearly = 59.4;
        overviewFiltered[0].total = 4.95; // FIXED HARD
        // overviewFiltered[0].yearly =
        //   this.products.filter((x) => x.id === 61)[0].price * 12;
        // overviewFiltered[0].total = this.products.filter(
        //   (x) => x.id === 61
        // )[0].price;
      });
    },
    setProduct6() {
      let supplier = this.defaultSupplier(this.energieGroups[6]);
      // let duration = this.durations.filter(x => x.rate_period_id === supplier.rate_period)

      if (this.overview.filter((x) => x.id === 6).length !== 1) {
        this.form.data.fields
          .filter(
            (x) =>
              x.type === "products" &&
              (x.defaultProducts.includes(1) || x.defaultProducts.includes(2))
          )[0]
          .defaultProducts.push(6);
        this.overview.push({
          id: 6,
          product: "Electricity or Gas", //changed all "Electricity and Gas" see https://1drv.ms/u/s!AgAb2EFdzDWmf-TfIWjBAJ5jsCc?e=UuVWs2
          supplier: {
            id: supplier.supplier_id,
            proposition: supplier.id,
            name: supplier.name,
            title: supplier.title,
          },
          duration: "",
          total: 0,
          discount: 0,
          yearly: 0,
          visible: 1,
          rates: [],
          packages: [],
          widgets: [],
          group: this.energieGroups[6],
          details: null,
        });
        this.setRates(1);
        this.setRates(2);
      }
    },
    setRates(product) {
      let propositions = [];
      let proposition = product;
      if ((product === 1 || product === 2) && this.checkElectricGas) {
        proposition = 6;
      }

      this.getPropositions(proposition).forEach((item) => {
        propositions.push(item.id);
      });

      if (propositions.length > 0) {
        if (proposition === 6) {
          if (this.overview.filter((item) => item.id === 6).length > 0) {
            this.overview.filter((item) => item.id === 6)[0].rates = [];
          }
        }

        this.getRates({
          propositions: propositions,
          product_id: product,
          meter_type: this.meter,
        }).then((response) => {
          let rates = response.data.data.rates;
          let overview = this.filterOverview(product);
          if (!overview) {
            return;
          }
          rates.forEach((item) => {
            item.parent =
              rates.filter((x) => x.parent_id === item.id).length > 0 ? 1 : 0;
            if (
              proposition === 6 &&
              this.overview.filter((item) => item.id === 6)[0]
            ) {
              this.overview.filter((item) => item.id === 6)[0].rates.push(item);
            }
          });
          if (response.data.data && overview) {
            overview.widgets = response.data.data.widgets
              ? response.data.data.widgets
              : [];
            overview.rules = response.data.data.rules;
            overview.rates = rates;
          }
          if (!overview || !overview.widgets) {
            return;
          }

          let widgetOverview =
            overview.widgets.filter(
              (a) =>
                a.type === "overview" && overview.supplier.id === a.supplier_id
            ) ?? null;
          if (widgetOverview) {
            widgetOverview.forEach((a) => {
              a.status = 1;
            });
          }
          if (response.data.data && response.data.data.details) {
            overview.details = response.data.data.details;
          }
          if (
            proposition === 6 &&
            this.overview.filter((item) => item.id === 6)[0]
          ) {
            this.overview.filter((item) => item.id === 6)[0].details =
              response.data.data.details;
          }
        });
      }
    },
    filterProduct(product) {
      let productReturn = [];
      this.form.data.fields
        .filter((x) => x.type === "products")
        .forEach((x) => {
          let findItem = x.products.filter((p) => p.id === product)[0];
          if (findItem) {
            productReturn = findItem;
          }
        });
      return productReturn;
    },
    filterOverview(item) {
      return this.overview.filter((o) => o.id === item)[0];
    },
    getGroupArray(group) {
      let groupArray = null;
      this.form.data.fields.forEach((x) => {
        if (Array.isArray(x) && x.filter((e) => e.group === group).length > 0) {
          groupArray = x;
        }
      });
      return groupArray;
    },
    defaultSupplier(group) {
      let suppliers = this.getGroupArray(group)
        ? this.getGroupArray(group).filter((x) => x.type === "suppliers")[0]
        : false;
      let defaultID = 0;
      if (suppliers) {
        if (
          group === "mobile" ||
          group === "internet" ||
          group === "bankaccount"
        ) {
          let defaultItem = suppliers.suppliers.filter(
            (x) => x.default !== null && x.default > 0 && x.show === 1
          );
          if (defaultItem.length <= 0) {
            let allShownSuppliers = suppliers.suppliers.filter(
              (x) => x.show === 1
            );

            if (!this.checkHasDefault(allShownSuppliers)) {
              let groupByCategory = allShownSuppliers.reduce((r, a) => {
                r[a.category_field] = [...(r[a.category_field] || []), a];
                return r;
              }, {});
              Object.values(groupByCategory).forEach((a) => {
                allShownSuppliers.filter((i) => i.id === a[0].id)[0].default =
                  a[0].id;
              });
            }

            defaultItem = suppliers.suppliers.filter(
              (x) => x.default !== null && x.default > 0 && x.show === 1
            );
          }

          suppliers.default =
            defaultItem.length > 0
              ? group === "mobile" && suppliers.groupDefault == "57"
                ? defaultItem.filter((a) => a.category_field == "call")[0]
                    .default
                : defaultItem[0].default
              : suppliers.suppliers[0]
              ? suppliers.suppliers[0].id
              : 0;
        } else {
          this.setDefaultSupplier(suppliers);
        }
        defaultID = suppliers.default;
      }
      return suppliers
        ? suppliers.suppliers.filter((y) => y.id === defaultID)[0]
        : [];
    },
    setDefaultSupplier(suppliers) {
      suppliers.default = suppliers.default
        ? suppliers.default
        : suppliers.suppliers[0]
        ? suppliers.suppliers[0].id
        : 0;

      suppliers.suppliers.forEach((item) => (item.default = suppliers.default));
    },
    checkHasDefault(arr) {
      return arr.some((a) => a.default !== null);
    },
    calcElectricConsumption() {
      let electricConsumption = 0;
      if (this.meter == 1) {
        // single meter
        electricConsumption = this.consumption.electric.single;
      } else {
        // double meter
        electricConsumption =
          this.consumption.electric.double.high +
          this.consumption.electric.double.low;
      }
      if (this.solar.status == 1) {
        // if using solar
        return electricConsumption - this.calcSolarConsumption();
      } else {
        // if not using solar
        return electricConsumption;
      }
    },
    calcSolarConsumption() {
      if (this.solar.status == "2") {
        return 0;
      }
      let solarConsumption = 0;
      if (this.solar.kwhKnown == 1) {
        // if solar kwh is known
        solarConsumption = this.solar.single;
        return parseInt(solarConsumption);
      } else {
        // if solar kwh is not known
        solarConsumption =
          this.solars.filter((x) => x.value == this.solar.number_of_panels)
            .length > 0
            ? this.solars.filter(
                (x) => x.value == this.solar.number_of_panels
              )[0].single
            : 0;
        return parseInt(solarConsumption);
      }
    },
    calcSolarConsumptionLow() {
      if (this.solar.status == "2") {
        return 0;
      }
      let solarConsumption = 0;
      if (this.solar.kwhKnown == 1) {
        // if solar kwh is known
        solarConsumption = this.solar.low;
        return parseInt(solarConsumption);
      } else {
        // if solar kwh is not known
        solarConsumption =
          this.solars.filter((x) => x.value == this.solar.number_of_panels)
            .length > 0
            ? this.solars.filter(
                (x) => x.value == this.solar.number_of_panels
              )[0].low
            : 0;
        return parseInt(solarConsumption);
      }
    },
    calcSolarConsumptionHigh() {
      if (this.solar.status == "2") {
        return 0;
      }
      let solarConsumption = 0;
      if (this.solar.kwhKnown == 1) {
        // if solar kwh is known
        solarConsumption = this.solar.high;
        return parseInt(solarConsumption);
      } else {
        // if solar kwh is not known
        solarConsumption =
          this.solars.filter((x) => x.value == this.solar.number_of_panels)
            .length > 0
            ? this.solars.filter(
                (x) => x.value == this.solar.number_of_panels
              )[0].high
            : 0;
        return parseInt(solarConsumption);
      }
    },
    checkConsumptionAndAddressResidential(item, name) {
      // if(item.field.includes("total")){
      //   return false
      // }
      if (name == "Electricity" || name == "Stroom") {
        let electricConsumption = this.calcElectricConsumption();
        if (this.meter == 1) {
          if (
            electricConsumption < 0 &&
            (item.field == "supply" ||
              item.field == "energy_ode_0_10000" ||
              item.field == "energy_tax_0_10000" ||
              item.field == "rate_single")
          ) {
            return false;
          } else if (
            electricConsumption > 0 &&
              (item.field == "return_delivery_single" || item.field == "return_delivery")
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          if (
            electricConsumption < 0 &&
            (item.field == "supply_double_low" ||
              item.field == "ode_double_low" ||
              item.field == "energy_tax_double_low" ||
              item.field == "supply_double_high" ||
              item.field == "ode_double_high" ||
              item.field == "energy_tax_double_high" ||
              item.field == "rate_double_low" ||
              item.field == "rate_double_high")
          ) {
            return false;
          } else if (
            electricConsumption > 0 &&
            (item.field == "return_delivery_double_low" ||
              item.field == "return_delivery_double_high")
          ) {
            return false;
          } else if (
            electricConsumption < 0 &&
              (item.field == "return_delivery_single" || item.field == "return_delivery")
          ) {
            return false;
          } else {
            return true;
          }
        }
      } else if (name == "Gas") {
        if (item.field == "return_delivery_single" || item.field == "return_delivery") {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    calcTotal(item, proposition, rates, name) {

      let total = 0;
      let overviewItem = this.filterOverview(item);
      // console.log(
      //   this.filterOverview(1)
      // .rates.filter(p => p.proposition_id === 5)
      // )
      var deduct = 0;
      this.filterOverview(item)
        .rates.filter((p) => p.proposition_id === proposition)
        .forEach((item) => {
          if (name == "Electricity" || name == "Stroom") {
            if (item.field == "return_delivery") {
              deduct = item.yearly_cost;
            }
            if (
              this.postcodeQuery &&
              this.postcodeQuery.network_operators["E"] &&
              !this.postcodeQuery.error &&
              item.field == "energy_charge_grid_operation"
            ) {
              item.rate = this.postcodeQuery.network_operators["E"]
                .filter((x) => x.connection_value == "3x25")[0]
                .daily.replace(",", ".");
              item.yearly_cost = parseFloat(
                this.postcodeQuery.network_operators["E"].filter(
                  (x) => x.connection_value == "3x25"
                )[0].yearly
              );
            }
          } else if (name == "Gas") {
            let gasConsumption = parseInt(this.consumption.gas);
            if (
              this.postcodeQuery &&
              !this.postcodeQuery.error &&
              item.field == "gas_charge_grid_operation"
            ) {
              let postCodeGasOperators = this.postcodeQuery.network_operators[
                "G"
              ];
              if (postCodeGasOperators) {
                if (500 > gasConsumption) {
                  item.rate = postCodeGasOperators
                    .filter((x) => x.connection_value == "G6 < 500 m3")[0]
                    .daily.replace(",", ".");
                  item.yearly_cost = parseFloat(
                    postCodeGasOperators
                      .filter((x) => x.connection_value == "G6 < 500 m3")[0]
                      .yearly.replace(",", ".")
                  );
                } else if (500 <= gasConsumption && gasConsumption < 4000) {
                  item.rate = postCodeGasOperators
                    .filter((x) => x.connection_value == "G6 < 4000 m3")[0]
                    .daily.replace(",", ".");
                  item.yearly_cost = parseFloat(
                    postCodeGasOperators
                      .filter((x) => x.connection_value == "G6 < 4000 m3")[0]
                      .yearly.replace(",", ".")
                  );
                } else if (gasConsumption >= 4000) {
                  item.rate = postCodeGasOperators
                    .filter((x) => x.connection_value == "G6 >= 4000 m3")[0]
                    .daily.replace(",", ".");
                  item.yearly_cost = parseFloat(
                    postCodeGasOperators
                      .filter((x) => x.connection_value == "G6 >= 4000 m3")[0]
                      .yearly.replace(",", ".")
                  );
                }
              }
            }
          }

          if (
            this.addressResidential &&
            this.checkConsumptionAndAddressResidential(item, name)
          ) {
            if (item.rate !== "0.0000" && item.parent != 1) {
              total += parseFloat(item.yearly_cost);
            }
          } else {
            if (
              item.rate !== "0.0000" &&
              item.parent != 1 &&
              item.field != "annual_tax_reduction" &&
              this.checkConsumptionAndAddressResidential(item, name)
            ) {
              total += parseFloat(item.yearly_cost);
            }
          }
        });
      let cashback =
        rates.cashbacks.filter((x) => x.proposition_id == proposition).length >
        0
          ? rates.cashbacks.filter((x) => x.proposition_id == proposition)[0]
              .per_yer_incl_vat
          : 0;
      if (this.checkElectricGas) {
        let yearlyTotal =
          this.filterOverview(1).yearly +
          this.filterOverview(2).yearly +
          parseFloat(cashback);
        this.filterOverview(6).yearly = yearlyTotal;
        this.filterOverview(6).total = yearlyTotal / 12;
      } else if (!this.checkElectricGas && this.filterOverview(1)) {
        this.filterOverview(1).yearly + parseFloat(cashback);
      } else if (!this.checkElectricGas && this.filterOverview(2)) {
        this.filterOverview(2).yearly + parseFloat(cashback);
      }

      overviewItem.yearly = total;
      overviewItem.total = total / 12;

      return total - deduct;
    },
    suppliersVisible(supplier, rate_period, group) {
      if (
        !Array.isArray(supplier) ||
        rate_period === null ||
        rate_period === undefined
      ) {
        return;
      }

      //unknown
      if (supplier.filter((x) => x.category_field === "reduction").length > 0) {
        rate_period2 = rate_period;
      } else if (group === "internet") {
        rate_period3 = rate_period;
      } else {
        rate_period4 = rate_period;
      }

      if (supplier.length > 0) {
        this.setSupplierDisable(rate_period, this.customertype, supplier);
      }
    },
    getRatePeriod(from) {
      if (from === "internet") {
        if (rate_period3 === 0) {
          return rate_period3 + 1;
        } else {
          return rate_period3;
        }
      } else if (from === "mobile") {
        if (rate_period4 === 0) {
          return rate_period4 + 1;
        } else {
          return rate_period4;
        }
      } else {
        if (rate_period2 === 0) {
          return rate_period2 + 1;
        } else {
          return rate_period2;
        }
      }
    },
    getPropositions(group) {
      let propItem = this.getGroupArray(this.energieGroups[group])
        ? this.getGroupArray(this.energieGroups[group]).filter(
            (item) => item.type === "suppliers"
          )[0]
        : false;
      return propItem ? propItem.suppliers : [];
    },
    removeProduct(item, data) {
      if (this.checkElectricGas && (item === 1 || item === 2) && !this.isLead) {
        this.overview.splice(
          this.overview.findIndex((x) => x.id === 6),
          1
        );
        data.defaultProducts.splice(data.defaultProducts.indexOf(6), 1);
        if (item === 1) {
          this.overview.filter((x) => x.id === 2)[0].visible = 1;
        }

        if (item === 2) {
          this.overview.filter((x) => x.id === 1)[0].visible = 1;
        }
      }
      data.defaultProducts.splice(data.defaultProducts.indexOf(item), 1);
      if (!this.isLead) {
        this.overview.splice(
          this.overview.findIndex((x) => x.id === item),
          1
        );
      }

      if (
        this.overview.length > 0 &&
        !this.checkElectricGas &&
        (item === 1 || item === 2)
      ) {
        if (item === 1) {
          this.setRates(2);
        }

        if (item === 2) {
          this.setRates(1);
        }
      }
    },
    sortedArray(array, parameter) {
      function compare(a, b) {
        if (a[parameter] < b[parameter]) return -1;
        if (a[parameter] > b[parameter]) return 1;
        return 0;
      }

      return array.sort(compare);
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    uniqueArray(data, parameter) {
      let uniqueItems = [];
      for (let i = 0; i < data.length; i++) {
        if (
          uniqueItems.filter((x) => x[parameter] === data[i][parameter])
            .length === 0
        ) {
          uniqueItems.push(data[i]);
        }
      }
      return uniqueItems;
    },
    groupBy(array, key) {
      const result = {};
      if (array) {
        array.forEach((item) => {
          if (!result[item[key]]) {
            result[item[key]] = [];
          }
          result[item[key]].push(item);
        });
      }
      return result;
    },
    groupByWithIgnore(array, key) {
      const result = {};
      if (array) {
        array.forEach((item) => {
          if (!result[item[key]]) {
            result[item[key]] = [];
          }
          result[item[key]].push(item);
        });
      }
      return result;
    },
    sprintf(format, ...args) {
      let i = 0;
      return format.replace(/%s/g, () => args[i++]);
    },
    scrollAnimate(selector) {
      let el = document.querySelector(selector);
      if (el) {
        let headerTop = window.location.search
          .split("&")
          .filter((x) => x.includes("top"))[0]
          ? parseInt(
              window.location.search
                .split("&")
                .filter((x) => x.includes("top"))[0]
                .split("=")[1]
            )
          : 122;
        parent.postMessage(
          { top: el.offsetTop, headerTop: headerTop, name: "myevent" },
          "*"
        );
        window.scroll({ top: el.offsetTop, behavior: "smooth" });
      }
    },
    getImage(item) {
      let url = "https://crm.propropertypartners.com"; //remote images path reference
      let res =
        !(item === undefined) && !(item === null)
          ? url + item
          : "/placeholder.png";
      return res;
    },
    setSupplierDisable(rate_period, customertype, supplier) {
      supplier
        .filter((item) => item.supplier_type == customertype)
        .forEach((item) => {
          if (rate_period === 0) {
            item.disabled = 0;
          } else if (item.rate_period === rate_period) {
            item.disabled = 0;
          } else if (Object.values(item.rate_period).includes(rate_period)) {
            item.disabled = 0;
          } else {
            item.disabled = 1;
          }
        });
    },
  },
});

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
